declare global {
  interface Window {
    posthog?: { capture: (event: string, props?: Record<string, unknown>) => void };
    gtag?: (...args: unknown[]) => void;
  }
}

// Google Ads conversion IDs — fill in after creating conversion actions in Google Ads
const GOOGLE_ADS_ID = "AW-18114856193"; // e.g. "AW-XXXXXXXXX"
const CONVERSION_LABELS: Record<string, string> = {
  trial_complete: "_5gQCLOKrKIcEIGK671D", // e.g. "abcDEFghIJ"
  signup_cta_click: "yOh3COihrqIcEIGK671D", // e.g. "klmNOPqrST"
};

export function trackEvent(event: string, props?: Record<string, unknown>): void {
  window.posthog?.capture(event, props);

  if (GOOGLE_ADS_ID && CONVERSION_LABELS[event] && window.gtag) {
    window.gtag("event", "conversion", {
      send_to: `${GOOGLE_ADS_ID}/${CONVERSION_LABELS[event]}`,
      ...props,
    });
  }
}
